import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import IconTelOrenge from '../../assets/images/common/icon-tel-orange.svg';
import ArrowBackBlue from '../../assets/images/common/arrow-back-blue.svg';

import { SCREEN_NAME } from '../../types/common/CommonType';

import { CoverProgressLoading } from '../../components/CoverProgressLoading';
import { addRow as setMoveScreen } from '../../slice/ScreenHistorySlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

type CompleteProps = {
    receiptNumber: string; // 受付番号
};

// 完了画面
export const Complete: React.FC<CompleteProps> = ({ receiptNumber }) => {
    const dispatch = useAppDispatch();
    const navigation = useNavigate();
    // 遷移履歴
    const screenHistory = useAppSelector((s) => s.ScreenHistory);

    useEffect(() => {
        // 直前画面が確認以外の場合は不正遷移と判断
        if (screenHistory[0] === SCREEN_NAME.CONFIRMATION) {
            // 画面遷移ルート追加
            dispatch(setMoveScreen(SCREEN_NAME.COMPLETE));
        } else {
            // 不正遷移の場合は検索TOPに遷移
            navigation('/');
        }
    }, []);

    return (
        <>
            {receiptNumber !== '' ? (
                <>
                    <section className='section page_title form_thanks'>
                        <div className='container'>
                            <div className='columns'>
                                <div className='column page_title-thead'>
                                    <h1>
                                        お問い合わせ・見積依頼、
                                        <br className='is-hidden-desktop' />
                                        ありがとうございました。
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='section thanks_message'>
                        <div className='container'>
                            <div className='columns'>
                                <div className='column'>
                                    <p>
                                        頂きましたお問い合わせ・概算見積依頼の受付番号を、ご入力いただいたメールアドレス宛に自動送信致しました。受け付けましたご依頼については弊社担当者にて確認後、近日中にご回答差し上げます。
                                    </p>
                                    <p>
                                        尚、受付メールが届かない場合やお急ぎの場合など、下記よりお電話いただく際に必要となりますので、受付番号は必ず別途お控えくださるようお願いいたします。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='section content-wrapper'>
                        <div className='container'>
                            <div className='columns thanks_num'>
                                <div className='column'>
                                    <div className='thanks_num--box'>
                                        受付番号 :<span>{receiptNumber}</span>
                                    </div>
                                    <div className='thanks_num--contact'>
                                        <span className='info'>データライブ株式会社　営業本部　営業窓口</span>
                                        <div className='thanks_num--wrapper'>
                                            <span className='icon'>
                                                <img src={IconTelOrenge} alt='' />
                                            </span>
                                            03-5684-5413
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='section bottom_cta'>
                        <div className='container'>
                            <div className='columns'>
                                <div className='column'>
                                    <div className='bottom_cta--next'>
                                        <Link to='/' className='button'>
                                            トップページに戻る
                                            <span className='icon is-small'>
                                                <img src={ArrowBackBlue} alt='' />
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <CoverProgressLoading />
            )}
        </>
    );
};
